import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";

const NAV = [
  { to: "/", label: "Home", end: true },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/government", label: "Government" },
  { to: "/contact", label: "Contact" },
];

const Logo = () => (
  <Link to="/" className="flex items-center" data-testid="nav-logo-link" style={{ textDecoration: "none" }}>
    <div
      style={{
        background: "var(--dark)",
        padding: "8px 16px",
        borderRadius: 8,
        display: "inline-flex",
        alignItems: "center",
      }}
    >
      <img src="/gt-logo.png" alt="Gravitas Technology — Turning Data Into Decisions" style={{ height: 48, width: "auto", display: "block" }} />
    </div>
  </Link>
);

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [pathname]);

  return (
    <header className={`nav-wrap ${scrolled ? "scrolled" : ""}`} data-testid="site-navbar">
      <div className="container-grav" style={{ height: 84 }}>
        <div className="flex items-center justify-between h-full">
          <Logo />

          <nav className="hidden lg:flex items-center gap-10">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
                data-testid={`nav-link-${n.label.toLowerCase()}`}
              >
                {n.label}
              </NavLink>
            ))}
            <Link to="/contact" className="btn" data-testid="nav-cta-consultation" style={{ padding: "12px 22px", fontSize: 14 }}>
              Let's talk
              <span className="arrow"><ArrowUpRight size={14} strokeWidth={2.5} /></span>
            </Link>
          </nav>

          <button
            className="lg:hidden flex items-center justify-center"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
            data-testid="nav-mobile-toggle"
            style={{ background: "transparent", border: "1px solid var(--line-2)", borderRadius: 100, width: 44, height: 44, color: "var(--ink)", cursor: "pointer" }}
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden" data-testid="nav-mobile-drawer" style={{ background: "var(--bg)", borderTop: "1px solid var(--line)", padding: "24px" }}>
          <div className="flex flex-col gap-5">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} end={n.end} className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`} style={{ fontSize: 20 }}>
                {n.label}
              </NavLink>
            ))}
            <Link to="/contact" className="btn" style={{ alignSelf: "flex-start", marginTop: 8 }}>
              Let's talk <span className="arrow"><ArrowUpRight size={14} /></span>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
